module.exports = __webpack_public_path__ + "img/service-resource03.921e0419.jpg";